import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@shared/services/notifications/notification.service';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  private readonly notificationService: NotificationService = inject(NotificationService);
  private readonly translateService: TranslateService = inject(TranslateService);

  copy(text: string, infoKey: string = 'common.copySuccess'): void {
    navigator.clipboard.writeText(text).then(() => {
      this.notificationService.show(
        'Info',
        this.translateService.instant(infoKey),
        'info'
      );
    }).catch(() => {
      this.notificationService.show(
        'Error',
        this.translateService.instant('common.copyError'),
        'error'
      );
    });
  }
}
